import { systemCode, xs_languageCode } from "../..";
import { byRanking } from "./byRanking";
import { getUrlPathSeo } from "./getUrlPathSeo";
import { getUrlPathSeoSettings } from "./getUrlPathSeoSettings";
import { parseMenuData } from "./parseMenuData";
import { parseTournamentEvents } from "./parseTournamentEvents";

export function buildMenuData(menuData) {
    window.isCotaExtraEnabled = (menuData.ioes?.[systemCode] ?? null) != null;

    const data = {
        sport: parseMenuData(menuData.sps),
        sportById: {},
        tournamentByUniqueId: {},
        showIncreasedOddsButton: window.isCotaExtraEnabled
    };
    
    data.sport.forEach(sport => {
        sport.urlPath = (sport.descrizione.replace(/\s+/g, '-')).toLocaleLowerCase();
        sport.urlPathSuffix = `_${sport.id}`;
        sport.urlPathSeo = getUrlPathSeo(sport);
        sport.urlPathSeoSettings =  getUrlPathSeoSettings(sport);
        data.sportById[sport.id] = sport;
        sport.categories.forEach(function(category, i) {
            category.urlPath = (sport.urlPath+'/'+category.descrizione.replace(/\s+/g, '-')).toLocaleLowerCase();
            category.urlPathSuffix = `_${sport.id}_${category.id}`;
            category.urlPathSeo = getUrlPathSeo(category);
            category.urlPathSeoSettings = getUrlPathSeoSettings(category);
            category.sportRef = sport.id;
            const uniqueId = `${sport.id}_${category.id}`;
            category.uniqueId = uniqueId;
            
            if (i === 0) {
                sport.categoryById = {};
            }
            sport.categoryById[category.id] = category;
            category.tournaments.forEach((tournament, i) => {
                tournament.urlPath = (sport.urlPath+'/'+tournament.descrizione.replace(/\s+/g, '-')).toLocaleLowerCase();
                tournament.urlPathSeo = getUrlPathSeo(tournament);
                tournament.urlPathSeoSettings = getUrlPathSeoSettings(tournament);
                tournament.sportRef = sport.id;
                tournament.categoryRef = category.id;
                const uniqueId = `${category.uniqueId}_${tournament.id}`;
                tournament.uniqueId = uniqueId;
                tournament.urlPathSuffix = `_${tournament.uniqueId}`;
                tournament.categoryUrlPath = category.urlPath;
                tournament.categoryUrlPathSuffix = category.urlPathSuffix;
                tournament.categoryUrlPathSeo = getUrlPathSeo(category);
                tournament.categoryUrlPathSeoSettings = getUrlPathSeoSettings(category);
                tournament.sportUrlPath = sport.urlPath;
                tournament.sportUrlPathSuffix = sport.urlPathSuffix;

				if (i === 0) {
                    category.tournamentById = {};
                }

                if (tournament.events.length > 0) {
                    const aggregate = tournament.aggregate.map(ag => ag.idAggregata);
                    tournament.events = parseTournamentEvents(data, tournament, aggregate, tournament.ba, false, false);
                }
                category.tournamentById[tournament.id] = tournament;
                data.tournamentByUniqueId[uniqueId] = tournament;
            });
        });
    });

    // Merges two sports into one
    function mergeSport(target, source) {
        Object.assign(target.filters, source.filters);
        target.categories = target.categories.concat(source.categories);
        target.categories.forEach(function(c){
            if(c){
                c.sportScRef = target.id;
            }
        })
        target.isLive = source.isLive ? true : target.isLive;
        target.eventsCount += source.eventsCount;
    }

    // Here we process sports groupings (i.e. multiple sports merged into one)
    // At the end of the process toRemove contains the IDs of the sports that have been merged into their respective grouping,
    // which need to be removed from the final sports list (but they have to be kept in the map for future reference)
    const toRemove = new Set();
    menuData.scd && menuData.scd.lst && menuData.scd.lst.forEach(g => {
        // The first sport of the grouping is used as the base
        const firstSport = data.sportById[g.sps[0]];
        if (firstSport == null) {
            return;
        }
        toRemove.add(firstSport.id);
        const desc = g.dsl[xs_languageCode];
        const sport = {
            ...firstSport,
            descrizione: desc,
            iconClass: g.ico,
            id: `sc-${g.cid}`,
            ranking: g.rnk,
            urlPath: (desc.replace(/\s+/g, '-')).toLocaleLowerCase(),
            urlPathSuffix: `_sc-${g.cid}`
        };
        // Iterate though all the other sports of the grouping
        g.sps.slice(1).forEach(id => {
            const sp = data.sportById[id];
            if (sp == null) {
                return;
            }
            toRemove.add(sp.id);
            const toMerge = {...sp};
            // Merge the current sport with the base sport of the grouping
            mergeSport(sport, toMerge);
        });

        data.sport.push(sport);
        data.sportById[sport.id] = sport;
    });

    // Remove the sports that have been grouped into other sports
    data.sport = data.sport.filter(sp => !toRemove.has(sp.id)).sort(byRanking);

    return data;
}
